import alert_mixin from "@/utils/mixins/alert_mixin";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import ConditionQuestionAssignment from "@/components/probaworkflows_base_components/ConditionQuestionAssignement/ConditionQustionAssignment.vue";
import condition_management_mixin from "@/utils/mixins/compliance_mixins/condition_management_mixin";

export default {
  name: "ConditionManagement",
  mixins: [alert_mixin, condition_management_mixin],
  components: { NavigationBackButton, ConditionQuestionAssignment },
  data: () => ({
    token: null,
    csrfToken: "",
    selected_rule: null,
    rule_conditions: [],
    is_loading_conditions: false,
    is_deleting: false,
    current_form_id: null,
    current_form_name: "",
    condition_form: {
      id: null,
      rule_id: null,
      condition_type: "",
      operator: "",
      value: "",
      comparison_value: "",
      selected_options: [],
      compliance_field: null,
      result_action_question: null,
      checklist_item_assignment: null,
      version: 1,
    },
    errors: {},
    is_saving_condition: false,
    condition_to_delete: null,
    conditionModal: null,
    deleteConditionModal: null,
    condition_type_options: [],
    operator_options: [],
    compliance_fields: [],
    result_action_questions: [],
    checklist_items: [],
    show_assign_modal: false,
    entity_type_id: null,
    condition_for_assignment: null,
    dataTable: null,
  }),
};
